import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";

class LinearRegressionInterceptSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForIntercept = this.yAccessorForIntercept.bind(this);
  }

  yAccessorForIntercept(d) {
    const { yAccessor } = this.props;
    return yAccessor(d);
  }

  render() {
    const { className, stroke, onDoubleClick, onContextMenu } = this.props;

    const resolvedStroke =
      typeof stroke === "string" ? { color: stroke } : stroke;

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        <LineSeries
          yAccessor={this.yAccessorForIntercept}
          stroke={resolvedStroke}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

LinearRegressionInterceptSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  stroke: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

LinearRegressionInterceptSeries.defaultProps = {
  className: "react-stockcharts-linear-regression-intercept-series",
  stroke: { color: "#E040FB", dash: "Solid", width: 2, opacity: 1 },
};

export default LinearRegressionInterceptSeries;
